import React from 'react';

import {
  type NavFeatureFlags,
  useNavFeatureFlags,
} from '../hooks/useNavFeatureFlags';

type FeatureFlaggedProps = React.PropsWithChildren<{
  featureFlag: keyof NavFeatureFlags;
  inverse?: boolean;
}>;

/**
 * Renders its children only if the specified feature flag is active.
 *
 * @example
 * <FeatureFlagged featureFlag="IncludeAsset">
 *   <div>This is a new feature!</div>
 * </FeatureFlagged>
 *
 * @param props
 * @param props.featureFlag The name of the feature flag to check. **Flag property must be in the redux.d.ts FeatureFlags type**
 * @param props.inverse If true, renders children when the feature flag is inactive.
 */
export function FeatureFlagged({
  featureFlag,
  inverse = false,
  children,
}: Readonly<FeatureFlaggedProps>) {
  const flagValue = useNavFeatureFlags()[featureFlag];

  const isActive = inverse ? !flagValue : flagValue;

  if (!isActive) return null;

  return children as React.ReactElement;
}
